import { render, staticRenderFns } from "./AxCloudInfoDescription.vue?vue&type=template&id=bf87e130&scoped=true&"
import script from "./AxCloudInfoDescription.vue?vue&type=script&lang=ts&"
export * from "./AxCloudInfoDescription.vue?vue&type=script&lang=ts&"
import style0 from "./AxCloudInfoDescription.vue?vue&type=style&index=0&id=bf87e130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf87e130",
  null
  
)

export default component.exports